class Slideshow {
	constructor($dom){
		this.target 	= $dom.querySelector("ul");
		this.current 	= 0;
		this.list 		= this.target.querySelectorAll("li");
		this.max 		= this.list.length / 2;
		//console.log(this.current, this.max);
	}
	inc(){
		this.current++;
		this.change();
	}
	change(){
		let posX = -100*this.current;
		this.target.style.transform = `translate3d(${posX}%, 0, 0)`;
		
		let $this = this;
		if($this.current === $this.max){
			setTimeout(function(){
				$this.current = 0;
				$this.target.classList.add("no_transition");
				setTimeout(function(){
					let posX = -100*$this.current;
					$this.target.style.transform = `translate3d(${posX}%, 0, 0)`;
					setTimeout(function(){
						$this.target.classList.remove("no_transition");
					}, 50);
				}, 50);
			}, 1000);
		}
	}
}

export let slide = {
	arry: [],
	start: 0,
	duration: 4000,
	init: function(){
		let slides = document.querySelectorAll("[data-slideshow]");
		slides.forEach( ($slide, index) => {
			//console.log($slide);
			slide.arry[index] = new Slideshow($slide);
		});
		slide.start = slide.getNow();
		slide.timer = setInterval( function(){
			slide.check();
		}, 100 );
	},
	getNow: function(){
		let n = new Date();
		return n.getTime();
	},
	check: function(){
		let current = slide.getNow();
		let diff = current - slide.start;
		if(diff >= slide.duration){
			slide.start = slide.getNow();
			for(let i = 0; i < slide.arry.length; i++){
				slide.arry[i].inc();
			}
		}
	}
}